import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./locales/fr/translation.json";
import it from "./locales/it/translation.json";

export const supportedLanguages = ["it", "fr"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

const storageKey = "princibo-language";

const detectLanguage = (): SupportedLanguage => {
  const stored = localStorage.getItem(storageKey);
  if (stored != null && (supportedLanguages as readonly string[]).includes(stored)) {
    return stored as SupportedLanguage;
  }
  const browserLang = navigator.language?.slice(0, 2).toLowerCase();
  if (browserLang != null && (supportedLanguages as readonly string[]).includes(browserLang)) {
    return browserLang as SupportedLanguage;
  }
  return "it";
};

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    it: { translation: it },
  },
  lng: detectLanguage(),
  fallbackLng: "it",
  supportedLngs: supportedLanguages as unknown as string[],
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem(storageKey, lng);
});

export default i18n;
